import React, { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

function CallbackPage() {
  const { handleRedirectCallback, isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current || isLoading) {
      return;
    }

    const processCallback = async () => {
      processed.current = true;
      const queryParams = new URLSearchParams(window.location.search);

      if (queryParams.has('code') && queryParams.has('state')) {
        try {
          console.log("Processing Auth0 redirect callback...");
          await handleRedirectCallback();
          console.log("Callback processed successfully. Navigating to models.");
          navigate('/models');
        } catch (e) {
          console.error("Error processing redirect callback:", e);
        }
      } else {
        console.warn("Callback page loaded without necessary query parameters. Redirecting home.");
        navigate('/');
      }
    };

    processCallback();
  }, [handleRedirectCallback, navigate, isLoading]);

  if (isLoading) {
    return <div>Loading authentication session...</div>;
  }

  if (error) {
    return (
      <div>
        <h1>Error during login</h1>
        <p>There was an error processing your login. Please try again.</p>
        <pre style={{ color: 'red' }}>{error.message}</pre>
        <button onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  return <div>Processing login...</div>;
}

export default CallbackPage; 